import { render, staticRenderFns } from "./CompensationProcedureView.vue?vue&type=template&id=7cf30599&scoped=true"
import script from "./CompensationProcedureView.vue?vue&type=script&lang=js"
export * from "./CompensationProcedureView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf30599",
  null
  
)

export default component.exports